var map = {
	"./Anast.png": 8978,
	"./Ani.png": 854,
	"./Anna.png": 8295,
	"./Artem.svg": 792,
	"./Bentsak.png": 6619,
	"./Bohdan.png": 7207,
	"./Brovchenko.png": 9007,
	"./Chuyko.png": 1708,
	"./Irina.png": 7460,
	"./Marunyak.png": 2493,
	"./Mikola.png": 7265,
	"./Mintuk.png": 7301,
	"./Mulyarska.png": 4648,
	"./Onistuk.png": 7336,
	"./Orest.png": 310,
	"./Savikina.png": 5808,
	"./Sergiy.png": 6573,
	"./Uriy.png": 5700,
	"./UriyL.png": 6575,
	"./Vlad.png": 9179,
	"./Zubenko.png": 2211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7415;